import request from '@/utils/request'

// 告警通知列表
export const noticeList = (params)=>{
  return request({
    url: '/admin-api/client/pc/alarm-notice/page',
    method: 'get',
    params: params
  })
}

// 通知详情
export const noticeDetail = (params)=>{
  return request({
    url: '/admin-api/client/pc/alarm-notice/get/all',
    method: 'get',
    params: params
  })
}
